export default __webpack_public_path__ + "f7d7fdc57424cf27410287f64d56ddaa.svg";